import { useInView } from '../../../hooks/useInView';

export default function CaseStudies() {
  const { ref, inView } = useInView();

  const cases = [
    {
      label: 'Healthcare',
      title: 'MedSpa Network — Multi-Location',
      description: 'Streamlined patient intake and follow-up systems across three locations.',
      result: 'Increased rebooking rates and reduced front-desk workload.',
      image: 'https://public.readdy.ai/ai/img_res/25ddc0038bf63fab0030ead7b7eb6cf4.jpg',
    },
    {
      label: 'Home Services',
      title: 'Regional Roofing Company',
      description: 'Implemented intelligent lead routing and follow-up automation.',
      result: 'Faster estimates and significantly improved close rates.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20aerial%20view%20of%20beautiful%20new%20residential%20roofing%20project%20on%20upscale%20home%2C%20pristine%20clean%20shingles%20in%20warm%20terracotta%20tones%2C%20lush%20suburban%20neighborhood%20visible%20below%2C%20clear%20blue%20sky%20backdrop%2C%20high%20quality%20commercial%20real%20estate%20photography%20style%2C%20sharp%20detail%20and%20contrast%2C%20professional%20workmanship%20showcase%2C%20no%20people&width=1400&height=900&seq=case-roofing-002&orientation=landscape',
    },
    {
      label: 'Legal Services',
      title: 'Boutique Law Firm',
      description: 'Built secure client intake and workflow visibility systems.',
      result: 'Reduced administrative time and improved client onboarding.',
      image: 'https://readdy.ai/api/search-image?query=Prestigious%20boutique%20law%20office%20with%20sophisticated%20dark%20walnut%20wood%20paneling%20and%20floor-to-ceiling%20bookshelves%20lined%20with%20leather-bound%20legal%20volumes%2C%20antique%20brass%20desk%20lamp%20casting%20warm%20pool%20of%20light%2C%20premium%20leather%20chair%2C%20manhattan%20skyline%20visible%20through%20large%20window%2C%20no%20people%20present%2C%20cinematic%20moody%20lighting%20with%20rich%20dark%20tones&width=1400&height=900&seq=case-legal-002&orientation=landscape',
    },
  ];

  return (
    <section className="bg-[#f7f7f7] py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div
          ref={ref}
          className={`flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div>
            <p className="text-teal-600 text-xs font-semibold tracking-[0.2em] uppercase mb-4">Case Studies</p>
            <h2 className="font-serif text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
              Elevation in Action.
            </h2>
          </div>
          <a href="#case-studies" className="text-slate-500 hover:text-teal-600 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2 group">
            View Full Case Studies
            <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
          </a>
        </div>

        <div className="space-y-4">
          {cases.map((c, i) => (
            <div
              key={i}
              className={`group relative overflow-hidden rounded-2xl cursor-pointer transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-slate-900/80 via-slate-900/40 to-transparent" />
              </div>

              <div className="absolute inset-0 flex items-center px-12">
                <div className="max-w-lg">
                  <span className="inline-block bg-teal-500/20 text-teal-300 text-xs px-3 py-1 rounded-full tracking-wider mb-4 backdrop-blur-sm">
                    {c.label}
                  </span>
                  <h3 className="font-bold text-2xl lg:text-3xl text-white mb-3">{c.title}</h3>
                  <p className="text-white/60 text-sm mb-3 leading-relaxed">{c.description}</p>
                  <p className="text-teal-300 text-sm font-medium">
                    Result: {c.result}
                  </p>
                </div>
              </div>

              <div className="absolute bottom-6 right-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="flex items-center gap-2 text-white/80 text-sm">
                  <span>Read case study</span>
                  <i className="ri-arrow-right-line" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
